module.exports = __webpack_public_path__ + "media/customizations/fccsa/logo-new-db2fc0e55ef105337e69b4720f368599.png";